/* 斯洛伐克 */
const sk = {
    next: 'Ďalej',
    error: 'Chyba',
    notFound: '404 Nenájdené.',
    m: {
        loginTitle: "Odomknite svoju power banku",
        phonePlaceholder: "Mobilné číslo",
        or: 'alebo',
        emailLogin: 'Pokračovať s e-mailom',
        phoneLogin: 'Pokračovať s telefónom',
        quickLogin: 'Pokračovať ako hosť',
        loginRequiredTip: 'Najprv sa prihláste',
        continueGoogle: "Pokračovať s Google",
        continueApple: "Pokračovať s Apple",
        langBoxTitle: "Vyberte jazyk",
        policyAndTerms: "Súhlasíte s podmienkami služby <a href='[termsOfServiceUrl]'>[brandName]</a> a <a href='[privacyPolicyUrl]'>Zásadami ochrany osobných údajov</a>.",
        verifyTitle: 'Zadajte 6-miestny kód, ktorý bol odoslaný na číslo [phonenumber]',
        verifyEmailTitle: 'Zadajte 6-miestny kód, ktorý bol odoslaný na číslo [email]',
        paymentTitle: 'Odomknite svoju power banku',
        resend: "Znova odoslať kód",
        emailAddress: "Emailová adresa",
        registerTitle: 'Zadajte svoje údaje.',
        fNameInput: 'Meno',
        lNameInput: 'Priezvisko',
        emailInput: 'Emailová adresa',
        birthInput: 'Dátum narodenia',
        postCodeInput: 'PSČ',
        billingRate: 'Sadzba',
        unpaidPopupSubtitle: "Máte nepreplatenú objednávku",
        unpaidPopupContent: "Máte nepreplatenú objednávku. Prosím, uhradte platbu predtým, ako si budete môcť opäť prenajať.",
        payNow: "Zaplať teraz",
        add: "Pridať",
        minBalanceTag: 'Min.: {amount}',
        paymentSuccessfulSubtitle: "Platba úspešná!",
        paymentSuccessfulContent: "Teraz môžete pokračovať v prenájme!",
        goToRental: "Prejsť na prenájom",
        repaymentTitle: "Platba za objednávku",
        rentalInformation: "Informácie o prenájme",
        selectPayMethod: 'Vyberte spôsob platby',
        selectAuthorizationMethod: 'Vyberte spôsob autorizácie',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Zostatok',
        creditOrDebit: 'Kreditná alebo debetná karta',
        free: 'Zadarmo',
        pay: 'Zaplatiť',
        confirm: 'Potvrdiť',
        cancel: 'Zrušiť',
        unlockNow: 'Odomknúť powerbank',
        savePay: 'Uložiť a zaplatiť',
        saveRent: 'Prenajať',
        recharge: 'Dobitie',
        balancePopupTitle: 'Dobitie',
        balancePopupCurrentBalance: 'Aktuálny zostatok: {amount}',
        balancePopupMinRentBalance: 'Minimálny zostatok na prenájom: {amount}',
        topUpRent: 'Dobitie',
        topUpSaveCard: 'Dobitie',
        bindPopupTitle: 'Pridať platobnú kartu',
        cardPaymentTitle: 'Platba s kartou',
        preparingTitle: 'Pripravuje sa vaša nabíjačka',
        preparingSubtitle: 'Vaša power banka sa vysúva. Prosím, počkajte chvíľu.',
        preparingStationBusySubtitle: 'Čakáme, kým sa dokončí predchádzajúce vysunutie. Prosím, počkajte.',
        rentalSuccessTitle: 'Úspech!',
        rentalFailTitle: 'Zlyhanie!',
        rentalSuccessSubtitle: 'Ďakujeme, že používate [brandName]. Prosím, vráťte power banku po použití.',
        rentalNumber: 'Číslo prenájmu',
        rentalTime: 'Čas prenájmu',
        rentalLocation: 'Miesto prenájmu',
        returnTime: "Čas vrátenia",
        returnLocation: "Miesto vrátenia",
        rentalDuration: "Dĺžka prenájmu",
        totalAmount: "Celková Čiastka",
        paidAmount: "Zaplatná Čiastka",
        unpaidAmount: "Splatná suma",
        currentFee: "Aktuálny poplatok",
        rentalInfo: 'Informácie o prenájme',
        rentingTitle: 'Práve používate powerbanku [brandName]',
        keepIt: 'Chcete si ju nechať? Kúpte si ju teraz!',
        findNearby: 'Nájdite ľahko blízke stanice na vrátenie – stiahnite si našu aplikáciu teraz!',
        nearbyStationTitle: 'Stanice v okolí',
        nearbyStationSearchPlaceholder: 'Hľadať blízke nabíjacie stanice',
        nearbyStationRent: 'Prenajať',
        nearbyStationReturn: 'Vrátiť',
        nearbyStationAvailable: 'Dostupné',
        nearbyStationEmpty: 'Prázdne',
        nearbyStationLoading: 'Načítavajú sa stanice v okolí...',
        nearbyStationNoStations: 'V okolí nie sú žiadne stanice',
        nearbyStationNoRentStations: 'V okolí nie sú žiadne stanice na prenájom',
        nearbyStationNoReturnStations: 'V okolí nie sú žiadne stanice na vrátenie',
        nearbyStationSearchAria: 'Hľadať stanice v okolí',
        nearbyStationType: 'Typ stanice',
        nearbyStationDistance: 'Vzdialenosť',
        scanForPowerbank: 'Skenovať powerbanku',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Stroje na vrátenie',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'Zobraziť ďalšie zariadenia v okolí',
        viewNearbyReturnLocations: 'Stroje na vrátenie',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'Aktuálny automat je pripravený',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Nájdite dostupný automat v okolí a naskenujte jeho kód.',
        mapIslandMachineUnavailableShort: 'Tento automat nie je dostupný',
        mapIslandMachineAvailableActionShort: 'Pokračovať s týmto automatom',
        mapIslandMachineUnavailableActionShort: 'Naskenujte iný automat',
        mapIslandReturnActionShort: 'Späť k prenájmu',
        rentingMapIslandTitle: 'Prenájom prebieha',
        tapToReturnRentalPage: 'Ťuknite pre návrat k prenájmu.',
        scan: 'Skenovať',
        scannerHint: 'Nájdite QR kód na nabíjacej stanici',
        flashlight: 'Baterka',
        mapBack: 'Späť',
        currentLocation: 'Aktuálna poloha',
        backToMap: 'Späť na mapu',
        mapMenu: 'Menu',
        mapMenuYourInfo: 'Vase udaje',
        mapMenuLanguage: 'Jazyk',
        mapMenuHelp: 'Pomoc',
        helpTitle: 'Pomoc',
        helpReportProblem: 'Nahlásiť problém',
        helpChatWithUs: 'Chatujte s nami',
        chatWithUsTitle: 'Chatujte s nami',
        chatContactMethods: 'Spôsoby kontaktu',
        reportProblemTitle: 'Nahlásiť problém',
        reportDeviceCode: 'Kód zariadenia',
        reportScanQrCode: 'Naskenovať QR kód zariadenia',
        reportDeviceCodePlaceholder: 'Naskenujte QR kód zariadenia alebo zadajte ID zariadenia',
        reportProblemType: 'Problém',
        reportProblemTypeAria: 'Typ problému',
        reportProblemPowerBankNotEjected: 'Powerbanka sa nevysunula',
        reportProblemCannotChargeDevice: 'Nenabíja zariadenie',
        reportProblemOrderNotEnded: 'Objednávka neukončená',
        reportProblemCableDamagedLost: 'Kábel poškodený/stratený',
        reportProblemOther: 'Iné',
        reportTakePicture: 'Nahrať obrázok',
        reportChooseOrTakePicture: 'Nahrať obrázok',
        reportRemovePicture: 'Odstrániť fotku',
        reportDescribeProblem: 'Opíšte problém',
        reportDescriptionPlaceholder: 'Zadajte popis',
        reportFieldRequired: 'Povinné',
        reportFieldOptional: 'Voliteľné',
        reportSubmit: 'Odoslať',
        reportSubmittedSuccessfully: 'Úspešne odoslané',
        mapMenuLogin: 'Prihlásiť sa',
        mapMenuLogout: 'Odhlásiť sa',
        mapMenuLogoutSuccess: 'Odhlásené',
        mapMenuLoadingProfile: 'Načítava sa profil...',
        mapMenuLogoutConfirmTitle: 'Odhlásiť sa?',
        mapMenuLogoutConfirmContent: 'Pred ďalším prenájmom sa budete musieť znova prihlásiť.',
        profileTitle: 'Profil',
        profileSave: 'Ulozit',
        profileNoChanges: 'Aktualizujte prosim aspon jedno pole s hodnotou.',
        profileDeleteAccount: 'Odstranit',
        profileDeleteConfirmTitle: 'Odstranit ucet?',
        profileDeleteConfirmContent: 'Vsetky udaje vo vasom ucte budu natrvalo odstranene a po odstraneni budete odhlaseny.',
        closeScanner: 'Zavrieť skener',
        directions: 'Navigácia',
        call: 'Zavolať',
        cabinet: 'Stanica',
        addressUnavailable: 'Adresa nie je dostupná',
        open: 'Otvorené',
        closed: 'Zatvorené',
        opens: 'Otvára',
        closes: 'Zatvára',
        hoursUnavailable: 'Otváracie hodiny nie sú dostupné',
        mapUnavailable: 'Mapa nie je dostupná',
        googleMapsKeyNotConfigured: 'Kľúč Google Maps nie je nakonfigurovaný',
        googleMapsLoadFailed: 'Google Maps sa nepodarilo načítať',
        retry: 'Skúsiť znova',
        mapLoading: 'Načítava sa mapa...',
        mapReloading: 'Znova sa načítava mapa...',
        cameraUnavailable: 'Kamera nie je v tomto prehliadači dostupná',
        cameraPermissionDenied: 'Povolenie kamery bolo odmietnuté',
        cameraStartFailed: 'Kameru sa nepodarilo spustiť',
        flashlightUnsupported: 'Baterka nie je na tomto zariadení podporovaná',
        flashlightSwitchFailed: 'Baterku sa nepodarilo prepnúť',
        invalidQrCode: 'Neplatný formát QR kódu',
        noon: 'Poludnie',
        weekdayMonday: 'Pondelok',
        weekdayTuesday: 'Utorok',
        weekdayWednesday: 'Streda',
        weekdayThursday: 'Štvrtok',
        weekdayFriday: 'Piatok',
        weekdaySaturday: 'Sobota',
        weekdaySunday: 'Nedeľa',
        weekdayMon: 'Po',
        weekdayTue: 'Ut',
        weekdayWed: 'St',
        weekdayThu: 'Št',
        weekdayFri: 'Pi',
        weekdaySat: 'So',
        weekdaySun: 'Ne',
        orderDeatil: 'Podrobnosti objednávky',

        subsTitle: 'Vybrať plán',
        default: 'Predefinito',
        subscribeAndSave: 'Abbonamento e salvataggio',
        autoRenew: 'Rinnovo automatico',
        reachLimit: 'Limite di utilizzo raggiunto',
        paymentAuthorizationTitle: 'Autorizácia platby',
        paymentAuthorizationRequired: 'Vyžaduje sa autorizácia platby',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'Autorizácia je potrebná, ak prenájom môže presiahnuť váš plán alebo ak nie je pripojená platobná metóda pre možné dodatočné poplatky.',
        paymentAuthorizationDesc3: 'Bude vykonaná dočasná blokácia vo výške [amount]. Ak sa neuplatnia žiadne dodatočné poplatky, po vrátení bude celá suma uvoľnená; v opačnom prípade bude zvyšná suma vrátená po odpočítaní prípadných dodatočných poplatkov.',
        paymentAuthorizationDesc4: 'Pre tento prenájom si nižšie vyberte jednu z autorizačných metód.',

        totalCost: 'Costo totale',
        returnSuccessTitle: 'Úspešné vrátenie!',
        returnSuccessSubtitle: 'Ďakujeme, že používate [brandName].',
        rentAgain: 'Požičať znova',
        guestLoginTips: 'Táto funkcia vyžaduje formálny účet. Režim hosťa nie je k dispozícii. Chceli by ste sa prihlásiť?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] minút',
        freeTimeDesc: '[free_time] minút zadarmo',
        flatFeeDesc: '[flat_fee] paušálny poplatok za prvých [flat_fee_time] minút',
        lowLimitDesc: 'Minimálny poplatok: [low_limit]',
        topLimitDesc: 'Maximálny denný poplatok: [top_limit]',
        preAuthDesc: '[pre_auth_amount] bude predautorizované na vašom spôsobe platby',
        depositDesc: 'Ak nebude vrátené do [maximum_rental_time] hodín, bude účtovaný [deposit], a power bank vám bude patriť',
        ruleError: 'Chyba pravidla',
        noneRuleDesc: 'Žiadne pravidlá',
        taxIncluded: 'Vrátane dane',
        taxIncludedWithRate: 'Vrátane [tax]% dane'
    },
    subscriptionType: {
        1: 'Zadarmo [value] minút za predplatné obdobie',
        2: 'Zadarmo [value] minút za mesiac',
        3: 'Zadarmo [value] minút za týždeň',
        4: 'Zadarmo [value] minút za deň',
        6: 'Zadarmo [value] krát za predplatné obdobie',
        7: 'Zadarmo [value] krát za mesiac',
        8: 'Zadarmo [value] krát za týždeň',
        9: 'Zadarmo [value] krát za deň',
        unlimited: 'neobmedzený',
        unlimitedRentals: 'Neobmedzené prenájmy zadarmo za predplatné obdobie',
        durationLimit: 'Až [limit] minút bezplatného prenájmu na prenájom. Potom [price] za [price_time] minút',
        maxLimit: ', maximálne [top_limit] za deň',
    },
    subscriptionTitleType: {
        1: '[value] minút za predplatné obdobie',
        2: '[value] minút za mesiac',
        3: '[value] minút za týždeň',
        4: '[value] minút za deň',
        6: '[value] krát za predplatné obdobie',
        7: '[value] krát za mesiac',
        8: '[value] krát za týždeň',
        9: '[value] krát za deň',
        unlimited: 'Neobmedzený',
        unlimitedRentals: 'Neobmedzené prenájmy za predplatné obdobie',
    },
    subscriptionInfo: {
        period: 'Obdobie: [start] - [end]',
        usedShort: '([used]/[total] použité)',
        usage: 'Použitie: [total] celkom, [used] použité, [remaining] zostáva',
        usageUnlimited: 'Použitie: neobmedzené',
        autoRenew: 'Automatické obnovenie: [value]',
        autoRenewTrue: 'Ano',
        autoRenewFalse: 'Nie',
    },
    time: {
        day: 'deň | dní',
        hour: 'hodina | hodín',
        minute: 'minúta | minút',
        second: 'sekunda | sekúnd',
        month: 'mesiac | mesiacov',
        year: 'rok | rokov'
    },
    tMsg: {
        agreePolicy: 'Súhlasím s [brandName]’s Privacy Policy and Terms & Conditions',
        errorTel: 'Prosím vložte platné telefónne číslo',
        sendSuccess: 'Úspešne odoslané',
        inputAll: 'Prosím vložte všetky povinne informácie',
        wrongEmail: 'Nesprávny Email Formát',
        wrongBirthday: 'Prosim napíšte správny dátum narodenia',
        initPayFail: 'Platba zlyhala',
        bindTimeout: 'Čas na priradenie karty vypršal, skúste znova',
        bindSuccess: 'Karta bola úspešne priradená',
        subscriptionSuccess: 'Predplatné bolo úspešne zakúpené',
        bindFailed: 'Priradenie karty zlyhalo',
        paymentFailed: 'Platba zlyhala',
        loginError: 'Chyba prihlásenia',
        paymentMethodNotSupported: 'Nepodporovaný spôsob platby',
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "Chyba siete",
        1000: "Operácia zlyhala",
        30022: "Prosím vložte telefónne číslo v správnom formáte",
        30128: "Verifikačný kód poslaný veľakrát. Prosím skúste to neskôr",
        30129: "Chyba odoslania verifikačného kódu",
        //
        30101: 'Verifikačný kód je chybný alebo expiroval',
        // 租借
        50101: "Stanica sa nenašla",
        50105: "Máte vypršanú objednávku",
        50106: "Stanica je aktuálne offline",
        50108: "Aktuálne sa tu nenachádzajú voľné powerbanky",
        50109: "Chyba uvoľnenia powerbanky, prosím skúste to opäť",
        50113: 'Táto stanica vyžaduje účet',
        50114: 'Hostia nemôžu používať túto funkciu. Prihláste sa',
        50111: 'Chyba platby',
        50305: 'Chyba platby',
        80411: 'Chyba pridaní spôsobu platby',
        50103: 'žiadny platný spôsob platby',
        50206: 'Platba vašj poslednej objednávky zlyhala. Prosím obnovte spôsob platby',
    }
}
export default sk
